'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { InputField, InputFieldProps } from '../input-field/input-field.tsx';
import { Select, SelectProps } from '../select/select.tsx';
export type StateFieldProps = (SelectProps & InputFieldProps) & {
  isUS?: boolean;
};
export const StateField: React.FC<StateFieldProps> = t0 => {
  const $ = _c(18);
  let fieldProps;
  let t1;
  if ($[0] !== t0) {
    ({
      isUS: t1,
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
    $[2] = t1;
  } else {
    fieldProps = $[1];
    t1 = $[2];
  }
  const isUS = t1 === undefined ? true : t1;
  const {
    name
  } = fieldProps;
  const {
    setValue,
    getValues,
    clearErrors
  } = useFormContext();
  const [initialLoad, setInitialLoad] = useState(true);
  const [prevState, setPrevState] = useState(null);
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setInitialLoad(false);
    };
    t3 = [];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== clearErrors || $[6] !== getValues || $[7] !== initialLoad || $[8] !== name || $[9] !== prevState || $[10] !== setValue) {
    t4 = () => {
      if (!initialLoad && name) {
        const currVal = getValues()[name];
        setValue(name, prevState);
        setPrevState(currVal);
        clearErrors(name);
      }
    };
    $[5] = clearErrors;
    $[6] = getValues;
    $[7] = initialLoad;
    $[8] = name;
    $[9] = prevState;
    $[10] = setValue;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== isUS) {
    t5 = [isUS];
    $[12] = isUS;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t4, t5);
  if (isUS) {
    let t6;
    if ($[14] !== fieldProps) {
      t6 = <Select {...fieldProps} />;
      $[14] = fieldProps;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    return t6;
  }
  let t6;
  if ($[16] !== fieldProps) {
    t6 = <InputField {...fieldProps} />;
    $[16] = fieldProps;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};